/**
 * Boolean function to determine if article is a blog or a live blog
 * @param {Article} article
 * @returns {boolean}
 */
export const isBlogArticle = (article) => {
  const subType = article?.subType ?? null;
  return (subType === 'liveBlog' || subType === 'blog');
};
